import { render, staticRenderFns } from "./SGDistributedLogsSummary.vue?vue&type=template&id=4ada6b74"
import script from "./SGDistributedLogsSummary.vue?vue&type=script&lang=js"
export * from "./SGDistributedLogsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports